import { useInView } from 'react-intersection-observer';
import { type ShopByLookFieldsFragment } from '../../../../../__generated__/graphql-client-types';
import { normalizeConstructImage } from '../../../../../helpers/construct/page-content.helper';
import { type ShopByLookContent, type ContentComponent } from '../../../../../types/construct.types';
import { HomeShopByLook } from '../../../../home-components/shop-by-look/shop-by-look/shop-by-look.component';

export const transformShopByLookContent = (content: ShopByLookContent): ShopByLookFieldsFragment => ({
	__typename: 'HomePageShopByLook',
	id: '',
	slides: content.fields.slides.items.map((item) => {
		const { description, image, link, title } = item.fields;

		return {
			__typename: 'HomePageShopByLookSlide',
			title: title ?? '',
			description: description ?? '',
			image: normalizeConstructImage(image),
			trackingLink: {
				__typename: 'TrackingLink',
				name: title ?? '',
				url: link.linkUrl ?? '',
				tracking: link.trackingCode ?? ''
			}
		};
	})
});

// TODO: EFDC-37539 - Refactor HomeShopByLook to consume construct types directly and eliminate the transformer.
export const ShopByLookHandler: ContentComponent<ShopByLookContent> = ({ content }) => {
	const { ref, inView } = useInView({ triggerOnce: true });

	return <div ref={ref}>{inView && <HomeShopByLook {...transformShopByLookContent(content)} />}</div>;
};
